import { useMsal } from "@azure/msal-react";


export const AccessToken = () => {    
    
    const { instance, accounts } = useMsal();
    
    const accessTokenRequest:any = {
        scopes: [process.env.REACT_APP_SCOPE],
        account: accounts[0],
    };
    
    return [instance, accessTokenRequest]
}
